import React from 'react';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import { IconButton, Grid, Box } from '@material-ui/core';

const ZoomControl = ({ setZoom, zoom }) => {
  const gridStyle = {
    position: 'fixed',
    left: 0,
    top: 'calc(50% - 36px)',
    width: 36,
    boxShadow: 'rgba(0, 0, 0, 0.16) 4px 0px 4px',
    zIndex: 100,
    background: '#fff',
  };

  return (
    <Box style={gridStyle}>
      <Grid container>
        <Grid container>
          <IconButton onClick={() => setZoom(zoom && zoom + 1)}>
            <AddIcon />
          </IconButton>
        </Grid>
        <Grid container>
          <IconButton onClick={() => setZoom(zoom && zoom - 1)}>
            <RemoveIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ZoomControl;
